import React from 'react';

const Page404 = () => {
    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 w-full">
            <div className="rounded-lg bg-main-white p-8 text-center shadow-xl transform transition-all duration-500 ease-in-out animate-scaleUp">
                <h1 className="mb-4 text-4xl font-bold text-main-font animate-fadeInText">404</h1>
                <p className="text-gray-600 animate-fadeInText">Oops! The page you are looking for could not be found.</p>
            </div>
        </div>
    );
};

export default Page404;
